import CalendarMaintenance from "../../views/apps/calendar/CalendarMaintenance.vue";

import layouts from "../../layout";

export default {
  path: "/Agenda-maintenance",
  name: "agenda-maintenance",
  component: CalendarMaintenance,
  meta: {
    auth: true,
    searchable: true,
    title: "Agenda de Mantenimiento Preventivo",
    layout: layouts.navLeft,
    tags: ["calendar", "Agenda", "Mantenimiento"]
  }
};
